export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13512.6ab222e7.jpg";